import React from 'react';
import PropTypes from 'prop-types';
import Framework from '@beardeddevops/react.framework';
import API from "@beardeddevops/react.api";
import {Types} from "../index";
import CancelIcon from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button'

class ImportList extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			input: '',
			input_error: '',
			keys: []
		};
	}

	handleDataChange = (name, value) => {
		this.setState({
			'input': value,
			'input_error': ''
		})

		if (value.includes(',')) {
			this.handleImportListChange(value)
		}
	};

	handleImportListChange = (importListValue) => {
		let {keys} = this.state;
		let lines;

		if (!importListValue.length) {
			this.setState({importListError: 'Key list cannot be blank.'});
			return;
		}

		lines = importListValue.split(/[,\n]/)
			.map((line) => line.trim());

		keys = keys.concat(lines);
		keys = [...new Set(keys)];
		keys = keys.filter(function (el) {
			return el != null && el.trim() !== '';
		});

		this.setState({
			keys,
			keys_error: '',
			showImportListModal: false,
			importListValue: '',
			importListError: '',
			input: '',
			input_error: ''
		});
	}

	async handleSubmit() {
		if (this.state.keys.length === 0 && this.state.input.length === 0) {
			return;
		}
		let model = new API.BuildClass(Types.Av_Keys._name, API.RequestType.CREATE);
		model.object.key_value = this.state.keys.length > 0 ? this.state.keys : this.state.input;
		model.object.used = false;
		await model.submit(null, this.state.keys.length > 0 ? 'PUT_BULK' : API.RequestType.CREATE);
	}

	removeKey = (key) => {
		this.setState({keys: this.state.keys.filter(entry => entry !== key)});
	};

	render() {
		return (
			<div className="ImportList container">
				<div className="row">
					To bulk add AV keys copy them from a spreadsheet, or separate them by a new line or comma.
					<br />
					Format as follows: Product Name, Activation Key, License Code (optional), Purchased Date (optional), Expiration Date (optional), Order Number (optional)
				</div>
				<div className="row">
					<Framework.Elements.TextField
						property={{'name': 'input', ignore_validation: true}}
						value={this.state.input}
						error={this.state.input_error}
						update={this.handleDataChange}
						multiline={4}
						label=""
					/>
				</div>
				<div className={'form-group'}>
					{this.state.keys.length > 0 &&
						<div className={'row'}>
							{this.state.keys.map((key) =>
								<div key={key} className="col-3">
									{key}
									<Button
									onClick={() => {this.removeKey(key)}}
									>
										<CancelIcon/>
									</Button>
								</div>
							)}
						</div>
					}
				</div>
			</div>
		);
	}
}

export default ImportList;
